import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { CustomButton } from "../CustomButton";
import AINavigation from "./AINavigation";
import ConfigureAI from "./ConfigureAI";
import SourceUpload from "./SourceUpload";
import StartFlow from "./StartFlow";
import { useDispatch, useSelector } from "react-redux";
import * as Messag from "../../config/ToastMessage";

import {
  registerCompany,
  stopAIService,
  startAIService,
  checkCompanyRegistration,
  updateAICompany,
  fileUpload,
  updateFAQ,
} from "../../reducers/aiSlice";
import "./index.css";
import FAQ from "./FAQ";
import Loader from "../Loader";
import { useLayout } from "../../context/LayoutContext";
const AIbotDialog = ({ visible, onHide }) => {
  const { isLoading } = useSelector((state) => state.ai);
  const dispatch = useDispatch();
  const { toast } = useLayout();
  const [registrationForm, setRegistrationForm] = useState({});
  const [uploadedFile, setUploadedFile] = useState([]);
  const [url, setUrl] = useState(null);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState(1);
  const [renderComponetn, setRenderComponent] = useState(<ConfigureAI />);
  const [botFlowStatus, setBotFlowStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(false);
  const tabs = [
    { label: "Configure AI Feature", value: 1 },
    { label: "Input Source", value: 2 },
    { label: "FAQ", value: 3 },
    { label: "Start Your AI Flow", value: 4 },
  ];

  const checkStatus = async () => {
    try {
      const registrationResult = await dispatch(
        checkCompanyRegistration()
      ).unwrap();
      if (registrationResult) {
        setRegistrationForm({
          companySector: registrationResult.companySector,
          aiFeature: registrationResult.aiFeature,
          botTrigger: registrationResult?.botTrigger,
          aiBotName: registrationResult?.aiBotName,
        });
        setBotFlowStatus(registrationResult?.botStatus);
        if (registrationResult?.botStatus === "ACTIVE") {
          setActiveTab(4);
          setDisable(true);
        }
      }
    } catch (err) {
      setError(err.message || "An error occurred while checking status");
      setActiveTab(1);
    }
  };
  useEffect(() => {
    checkStatus();
    setUploadedFile([]);
    setUrl(null);
    setError(null);
  }, [visible, dispatch]);

  const handleRegistrationSubmit = async () => {
    try {
      await dispatch(registerCompany(registrationForm)).unwrap();
      setError(null);
      setActiveTab(activeTab + 1);
    } catch (err) {
      setError(err.message || "Registration failed");
    }
  };

  const handleStartService = async () => {
    try {
      let data = {
        botStatus: "ACTIVE",
      };
      await dispatch(updateAICompany(data)).unwrap();
      setActiveTab(3);
      checkStatus();
      setUrl(null);
      setUploadedFile(null);
      setDisable(true);
    } catch (err) {
      setError(err.message || "Failed to start AI service");
    }
  };

  const handleStopService = async () => {
    try {
      let data = {
        botStatus: "CLOSED",
      };
      await dispatch(updateAICompany(data)).unwrap();
      setActiveTab(1);
      checkStatus();
      setUrl(null);
      setUploadedFile(null);
      setDisable(false);
    } catch (err) {
      setError(err.message || "Failed to stop AI service");
    }
  };
  const handleCompanyUpdateSubmit = async () => {
    try {
      await dispatch(updateAICompany(registrationForm)).unwrap();
      setError(null);
      setActiveTab(activeTab + 1);
      checkStatus();
    } catch (err) {
      setError(err.message || "Failed to update company botconfiguration");
    }
  };

  const handleUploadFilesContents = async () => {
    setLoading(true);
    setError(null);

    try {
      const readFiles = async (files) => {
        const readers = files.map((file) => {
          return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = (e) =>
              resolve({ name: file.name, content: e.target.result });

            reader.onerror = () => reject(`Failed to read file: ${file.name}`);

            reader.readAsText(file);
          });
        });
        return Promise.all(readers);
      };
      const fileContents = await readFiles(uploadedFile);
      await dispatch(
        updateFAQ({ rawFAQs: fileContents?.[0]?.content, url: url ? url : "" })
      )
        .unwrap()
        .then((res) => {
          let Message_Success = Messag.Add_AIFile_ToastSuccessMessage;
          toast?.current?.show({
            severity: "success",
            detail: Message_Success,
          });
          setLoading(false);
          setActiveTab(activeTab + 1);
        })
        .catch((err) => {
          toast.current.show({ severity: "error", detail: err.message });
          setLoading(false);
        });
    } finally {
      setLoading(false);
    }
  };

  const handleNext = () => {
    switch (activeTab) {
      case 1:
        if (registrationForm?.aiFeature == "") {
          handleRegistrationSubmit();
        } else {
          handleCompanyUpdateSubmit();
        }
        break;
      case 2:
        if (uploadedFile || url) {
          handleUploadFilesContents();
        }
        break;
      case 3:
        setActiveTab(activeTab + 1);
        break;
    }
  };

  useEffect(() => {
    switch (activeTab) {
      case 1:
        setRenderComponent(
          <ConfigureAI
            registrationForm={registrationForm}
            setRegistrationForm={setRegistrationForm}
            disabled={disable}
          />
        );
        break;
      case 2:
        setRenderComponent(
          <SourceUpload
            uploadedFile={uploadedFile}
            setUrl={setUrl}
            url={url}
            setUploadedFile={setUploadedFile}
            disabled={disable}
          />
        );
        break;
      case 3:
        setRenderComponent(<FAQ disabled={disable} />);
        break;
      case 4:
        setRenderComponent(
          <StartFlow
            registrationForm={registrationForm}
            botFlowStatus={botFlowStatus}
          />
        );
        break;
      default:
        setRenderComponent(<ConfigureAI />);
    }
  }, [activeTab, url, uploadedFile, botFlowStatus]);

  return (
    <div className="flex justify-center items-center">
      <Dialog
        visible={visible}
        onHide={onHide}
        dismissableMask={false}
        closable={false}
        style={{ width: "65vw", minHeight: "98vh" }}
        draggable={false}
        header={
          <div
            className=""
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px",
            }}
          >
            <div>Create AI Flow</div>
           
            <div className="flex items-center gap-2">
              <CustomButton
                label="Cancel"
                varient="cancel"
                autofocus={true}
                onClick={onHide}
              />
              {activeTab < 4 && (
                <CustomButton
                  label={"Next"}
                  varient="filled"
                  onClick={handleNext}
                  disabled={isLoading}
                />
              )}
              {botFlowStatus === "ACTIVE" && activeTab === 4 && (
                <CustomButton
                  label="Stop AI"
                  varient="filled"
                  onClick={handleStopService}
                  disabled={isLoading}
                />
              )}
              {botFlowStatus === "CLOSED" && activeTab === 4 && (
                <CustomButton
                  label="Start AI"
                  varient="filled"
                  onClick={handleStartService}
                  disabled={isLoading}
                />
              )}
            </div>
          </div>
        }
      >
        {botFlowStatus === "ACTIVE" && <div className="m-2 start_ai_container">Your AI is now running and processing for changes please stop AI </div>}
        <div>
          <div className="navigation_ai_bot">
            <AINavigation
              navtabs={tabs}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              // disabled={botFlowStatus == "CLOSED" ? false : true}
            />
          </div>
          <Loader visible={loading} />
          <div className="ai_main_container"> {renderComponetn} </div>
        </div>
      </Dialog>
    </div>
  );
};

export default AIbotDialog;
